<template>
    <div id="modal-cover" :class="{ show: show}"></div>
</template>

<script>
    export default {
        name: "ModalCover",
        computed: {
            show: function () {
                return this.$store.state.modalCover;
            }
        }
    }
</script>